module.exports = __webpack_public_path__ + "static/dark-horse-5926b29f3c0445e1886fe6b400ec98e6.png";